import moment from 'moment';

/**
 * Util Functions
 */

/*
  객체에서 원하는 키값을 뽑아내는 함수
 */
const getValueOfField = (obj, field, emptyText = '') => {
  if (Object.keys(obj).length === 0) return emptyText;

  const idx = field.indexOf('.');

  if (idx === -1) {
    return obj[field];
  } else {
    const nextObj = obj[field.slice(0, idx)];
    const nextField = field.slice(idx + 1);

    return getValueOfField(nextObj, nextField);
  }
};

/*
  스트링에서 원하는 길이만큼 자르는 함수
*/

const textTruncate = (str, length = 100, ending = '...') => {
  const text = str.substring(0, length - ending.length);
  return str.length > length ? `${text}${ending}` : str;
};

/*
  날짜시간 관련 유틸
  서버에서 kst 변환이 되어 내려오는 YYYY-MM-DD HH:mm:ss 형태로 내려오는 값에 대한 변환 함수
*/

const getDateTime = (dateTime = '', format = 'YYYY-MM-DD HH:mm:ss', defaultMsg = '-') => {
  return dateTime ? moment(dateTime).format(format) : defaultMsg;
};

const getDate = (dateTime = '', format = 'YYYY-MM-DD', defaultMsg = '-') => {
  return dateTime ? moment(dateTime).format(format) : defaultMsg;
};

const getTime = (dateTime = '', format = 'HH:mm:ss', defaultMsg = '-') => {
  return dateTime ? moment(dateTime).format(format) : defaultMsg;
};

const getHourMinute = (dateTime = '', format = 'HH:mm', defaultMsg = '-') => {
  return dateTime ? moment(dateTime).format(format) : defaultMsg;
};

export { getValueOfField, textTruncate };
export default { getDateTime, getDate, getTime, getHourMinute };



// WEBPACK FOOTER //
// ./src/util/common/index.js